import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-primary-50" }
const _hoisted_2 = { class: "container max-w-6xl mx-auto px-4 py-12" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-12" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-display-sm font-heading font-bold text-primary-800 mb-4" }, " Get in Touch "),
  /*#__PURE__*/_createElementVNode("p", { class: "text-lg text-primary-500 max-w-2xl mx-auto" }, " Whether you're a current resident or future neighbor, reach out with any questions and we'll get back to you as soon as possible. ")
], -1)
const _hoisted_4 = { class: "grid lg:grid-cols-2 gap-12 items-start" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"space-y-6\"><div class=\"flex items-start gap-4 p-5 bg-white rounded-xl border border-primary-200 shadow-soft\"><div class=\"w-12 h-12 bg-accent-100 rounded-lg flex items-center justify-center flex-shrink-0\"><svg class=\"w-6 h-6 text-accent-700\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z\"></path><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M15 11a3 3 0 11-6 0 3 3 0 016 0z\"></path></svg></div><div><h3 class=\"font-semibold text-primary-800 mb-1\">Our Location</h3><p class=\"text-primary-500\">123rd and Beloit</p><p class=\"text-primary-500\">Greenfield, WI</p></div></div><div class=\"flex items-start gap-4 p-5 bg-white rounded-xl border border-primary-200 shadow-soft\"><div class=\"w-12 h-12 bg-accent-100 rounded-lg flex items-center justify-center flex-shrink-0\"><svg class=\"w-6 h-6 text-accent-700\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z\"></path></svg></div><div><h3 class=\"font-semibold text-primary-800 mb-1\">Email Address</h3><a href=\"mailto:info@foxwoodcrossing.com\" class=\"text-accent-600 hover:text-accent-700 transition-colors\"> info@foxwoodcrossing.com </a></div></div><div class=\"p-5 bg-accent-50 rounded-xl border border-accent-200\"><h3 class=\"font-semibold text-accent-800 mb-2\"> About Foxwood Crossing </h3><p class=\"text-accent-700 text-sm leading-relaxed\"> We&#39;re a welcoming community in Greenfield, Wisconsin. Whether you&#39;re looking for information about our neighborhood association, upcoming events, or just have general questions, we&#39;re here to help. </p></div></div>", 1)
const _hoisted_6 = { class: "bg-white rounded-xl border border-primary-200 shadow-soft p-8" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-heading font-semibold text-primary-800 mb-6" }, " Send us a message ", -1)
const _hoisted_9 = {
  key: 0,
  class: "text-red-600 text-sm bg-red-50 p-3 rounded-lg"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "block text-sm font-medium text-primary-700 mb-1"
}, " Your Name ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "block text-sm font-medium text-primary-700 mb-1"
}, [
  /*#__PURE__*/_createTextVNode(" Email Address "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  for: "phone",
  class: "block text-sm font-medium text-primary-700 mb-1"
}, " Phone Number ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "message",
  class: "block text-sm font-medium text-primary-700 mb-1"
}, [
  /*#__PURE__*/_createTextVNode(" Message "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*")
], -1)
const _hoisted_14 = {
  key: 1,
  type: "submit",
  class: "w-full px-6 py-3 text-white bg-accent-600 rounded-lg hover:bg-accent-700 transition-colors font-medium focus:outline-none focus:ring-2 focus:ring-accent-500 focus:ring-offset-2"
}
const _hoisted_15 = {
  key: 2,
  type: "button",
  class: "w-full px-6 py-3 text-white bg-accent-500 rounded-lg font-medium flex items-center justify-center",
  disabled: ""
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("svg", {
  class: "animate-spin -ml-1 mr-3 h-5 w-5 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    class: "opacity-25",
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    "stroke-width": "4"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    class: "opacity-75",
    fill: "currentColor",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
  })
], -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Sending... ")
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = {
  key: 1,
  class: "text-center py-8"
}
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<div class=\"w-16 h-16 bg-accent-100 rounded-full flex items-center justify-center mx-auto mb-4\"><svg class=\"w-8 h-8 text-accent-600\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M5 13l4 4L19 7\"></path></svg></div><h3 class=\"text-xl font-heading font-semibold text-primary-800 mb-2\"> Message Sent! </h3><p class=\"text-primary-500\"> Thank you for reaching out. We&#39;ll get back to you soon! </p>", 3)
const _hoisted_23 = [
  _hoisted_20
]

import { ref } from "vue";
import { HoodApi } from "@/services/HoodApi";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const email = ref("");
const name = ref("");
const phone = ref("");
const message = ref("");
const error = ref("");
const success = ref(false);
const loading = ref(false);

const submit = async () => {
  error.value = "";
  if (email.value === "" || message.value === "") {
    error.value = "Email and Message are both required";
    return;
  }
  loading.value = true;
  try {
    await HoodApi.create_contact_request(
      email.value,
      message.value,
      phone.value
    );
    success.value = true;
  } catch (e) {
    error.value = "Something went wrong. Please try again.";
  } finally {
    loading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          (!success.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("form", {
                  onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (submit()), ["prevent"])),
                  class: "space-y-5"
                }, [
                  (error.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(error.value), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", null, [
                    _hoisted_10,
                    _withDirectives(_createElementVNode("input", {
                      id: "name",
                      type: "text",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
                      placeholder: "John Smith",
                      class: "w-full px-4 py-3 text-primary-800 border border-primary-200 rounded-lg focus:ring-2 focus:ring-accent-500 focus:border-accent-500 transition-colors"
                    }, null, 512), [
                      [_vModelText, name.value]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_11,
                    _withDirectives(_createElementVNode("input", {
                      id: "email",
                      type: "email",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((email).value = $event)),
                      placeholder: "john@example.com",
                      class: "w-full px-4 py-3 text-primary-800 border border-primary-200 rounded-lg focus:ring-2 focus:ring-accent-500 focus:border-accent-500 transition-colors"
                    }, null, 512), [
                      [_vModelText, email.value]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_12,
                    _withDirectives(_createElementVNode("input", {
                      id: "phone",
                      type: "text",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((phone).value = $event)),
                      placeholder: "(555) 123-4567",
                      class: "w-full px-4 py-3 text-primary-800 border border-primary-200 rounded-lg focus:ring-2 focus:ring-accent-500 focus:border-accent-500 transition-colors"
                    }, null, 512), [
                      [_vModelText, phone.value]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_13,
                    _withDirectives(_createElementVNode("textarea", {
                      id: "message",
                      rows: "5",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((message).value = $event)),
                      placeholder: "How can we help you?",
                      class: "w-full px-4 py-3 text-primary-800 border border-primary-200 rounded-lg resize-none focus:ring-2 focus:ring-accent-500 focus:border-accent-500 transition-colors"
                    }, null, 512), [
                      [_vModelText, message.value]
                    ])
                  ]),
                  (!loading.value)
                    ? (_openBlock(), _createElementBlock("button", _hoisted_14, " Send Message "))
                    : (_openBlock(), _createElementBlock("button", _hoisted_15, _hoisted_18))
                ], 32)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_23))
        ])
      ])
    ])
  ]))
}
}

})